<mat-toolbar [color]="color">
  @for (row of input.rows; track row) {
    <mat-toolbar-row>
      <div
        class="toolbar-content-wrapper"
        [style.paddingLeft]="paddingLeft"
        [style.paddingRight]="paddingRight"
        [style.paddingTop]="paddingTop"
        [style.paddingBottom]="paddingBottom"
      >
        <ng-container [dynamicWidget]="row" [context]="context"></ng-container>
      </div>
    </mat-toolbar-row>
  }
</mat-toolbar>
